// Escape a single CSV cell — wrap in quotes if it contains a comma, quote, or
// newline; double any embedded quotes. Shared by every CSV export surface.
export const csvCell = (val) => {
  if (val === null || val === undefined) return '';
  const s = String(val);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

// Build a CSV string + trigger a browser download (UTF-8 BOM for Excel). Shared by every
// CSV export surface so quoting/encoding stays consistent.
export const downloadCsv = (filename, headers, rows) => {
  const csv = [headers.map(csvCell).join(','), ...rows.map((r) => r.map(csvCell).join(','))].join('\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
